// ATHL8 PDP Outfit Builder.
// Custom element <outfit-bundle>. Recomputes total on checkbox change.
// Add-all posts {items: [...]} to /cart/add.js and refreshes the cart drawer.
(function () {
  if (window.customElements && customElements.get('outfit-bundle')) return;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) { /* fall through */ }
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  function safeText(node, value) {
    if (node) node.textContent = value;
  }

  class OutfitBundle extends HTMLElement {
    connectedCallback() {
      this.cartAddUrl = this.getAttribute('data-cart-add-url') || '/cart/add';
      this.moneyFormat = this.getAttribute('data-money-format') || '€{{amount}}';
      this.checks = Array.prototype.slice.call(this.querySelectorAll('.outfit-bundle__check'));
      this.totalEl = this.querySelector('[data-total]');
      this.cta = this.querySelector('[data-add-all]');
      this.feedback = this.querySelector('[data-feedback]');

      this.checks.forEach(function (cb) {
        cb.addEventListener('change', this.updateTotal.bind(this));
      }.bind(this));

      if (this.cta) {
        this.cta.addEventListener('click', this.handleAddAll.bind(this));
      }
    }

    updateTotal() {
      var total = 0;
      this.checks.forEach(function (cb) {
        if (cb.checked) {
          var price = parseInt(cb.getAttribute('data-price'), 10);
          if (!isNaN(price)) total += price;
        }
      });
      safeText(this.totalEl, formatMoney(total, this.moneyFormat));
    }

    handleAddAll() {
      var items = [];
      this.checks.forEach(function (cb) {
        if (!cb.checked) return;
        var id = cb.getAttribute('data-variant-id');
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      if (items.length === 0) return;

      this.setBusy(true);
      this.clearFeedback();

      var self = this;
      fetch(this.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) {
            self.showFeedback(self.getMessage('error'), 'error');
            self.setBusy(false);
            return;
          }
          self.showFeedback(self.getMessage('success'), 'success');
          self.setBusy(false);
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        })
        .catch(function () {
          self.showFeedback(self.getMessage('error'), 'error');
          self.setBusy(false);
        });
    }

    setBusy(isBusy) {
      if (!this.cta) return;
      this.cta.disabled = !!isBusy;
      this.cta.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    showFeedback(text, state) {
      if (!this.feedback) return;
      this.feedback.textContent = text;
      this.feedback.setAttribute('data-state', state || '');
    }

    clearFeedback() {
      if (!this.feedback) return;
      this.feedback.textContent = '';
      this.feedback.removeAttribute('data-state');
    }

    getMessage(kind) {
      var nl = (document.documentElement.lang || '').toLowerCase().indexOf('nl') === 0;
      if (kind === 'success') return nl ? 'Toegevoegd aan winkelwagen.' : 'Added to cart.';
      return nl ? 'Kon niet toevoegen. Probeer opnieuw.' : 'Could not add. Try again.';
    }
  }

  customElements.define('outfit-bundle', OutfitBundle);
})();
